import { Col, Row } from "react-bootstrap";
import styles from "./charge-history-card.module.scss";

interface IProps {
  dateRange: string;
  chargerName: string;
  userName: string;
  id: string;
  usage: string | number;
}

const ChargeHistoryCard = ({
  dateRange,
  chargerName,
  userName,
  id,
  usage,
}: IProps) => {
  return (
    <div className={`${styles.historyCard} mb-3`}>
      <Row className="align-items-center justify-content-between">
        <Col className="col-auto">
          <Row>
            <Col className="col-auto">
              <span
                className={`font-size-12 font-weight-400 ${styles.dateText}`}
              >
                {dateRange}
              </span>
            </Col>
            <Col className="col-auto">
              <span className={`font-size-12 font-weight-400 text-dark me-1`}>
                {chargerName} -
              </span>
              {userName && (
                <span
                  className={`font-size-12 font-weight-400 ${styles.userName}`}
                >
                  {userName}
                </span>
              )}
              <span
                className={`font-size-12 font-weight-400 ${styles.idText} ms-1`}
              >
                {id}
              </span>
            </Col>
          </Row>
        </Col>
        <Col className="col-auto text-md-end text-start">
          <span className={`font-size-12 font-weight-600 text-dark`}>
            {usage}
          </span>
          <span className={`font-size-12 text-dark ms-1`}>kWh</span>
        </Col>
      </Row>
    </div>
  );
};

export default ChargeHistoryCard;
